export const routes = {
  splash: '/splash',
  landing: '/landing',
  login: '/login',
  loginEmail: '/login-email',
  signup: '/signup',
  otp: '/otp',
  forgotPassword: '/forgot-password',
  home: '/', // Default route - shows splash screen
  app: '/app', // Main app home page (after authentication)
  appFeed: '/app/feed',
  appSearch: '/app/search',
  appCreateReel: '/app/create-reel',
  appLocation: '/app/location',
  appProfile: '/app/profile',
  appNotifications: '/app/notifications',
  appAIChat: '/app/ai-chat',
  appReelsFeed: '/app/reels-feed',
  users: '/users',
  categories: '/categories',
  consultants: '/consultants',
  config: '/config',
  adminDashboard: '/admin',
  infrastructureDashboard: '/infrastructure',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  deleteAccount: '/delete-account',
  reels: '/reels',
  reelDetails: '/reel/:id',
  user: '/user/:id',
  chats: '/chats',
  profile: '/profile',
  partyEventDetails: '/party-event/:id',
  matchDetails: '/match/:id',
  apartmentDetails: '/apartment/:id',
  universitiesServices: '/universities',
  eventDetails: '/event/:id',
  restaurantDetails: '/restaurant/:id',
}